import {useCallback, useEffect} from 'react'
import {useForceUpdate} from './use-force-update'
import {isMobile} from '../shared/caps'
import {useIsMobile} from './use-is-mobile'

export const updateNavbarAlphas = (mobile = isMobile()) => {
    const footerDestAlpha = mobile ? .27 : .5
    const headerDestAlpha = mobile ? .57 : .5
    const headerAlpha = Math.min(Math.max(96 - window.scrollY / 3, 0) / 96 * (1-headerDestAlpha) + headerDestAlpha, 1)
    const footerAlpha = Math.min(Math.max(96 - (
        window.document.body.clientHeight - (window.scrollY + window.innerHeight)
    ) / 3, 0) / 96 * (1-footerDestAlpha) + footerDestAlpha, 1)
    document.documentElement.style.setProperty('--header-alpha', headerAlpha.toString())
    document.documentElement.style.setProperty('--footer-alpha', footerAlpha.toString())
}

export function useNavbarAlphas() {
    const forceUpdate = useForceUpdate()
    const isMobile = useIsMobile()
    const update = useCallback(() => updateNavbarAlphas(isMobile), [isMobile])

    useEffect(() => {
        const handleResize = () => {
            update()
            forceUpdate()
        }
        const targetNode = document.querySelector('[data-content="true"]')
        const observer = new MutationObserver(() => setTimeout(() => update(), 27))
        observer.observe(targetNode, {attributes: true, childList: true, subtree: true, characterData: true})
        window.addEventListener('scroll', update)
        window.addEventListener('resize', handleResize)
        handleResize()
        return () => {
            window.removeEventListener('scroll', update)
            window.removeEventListener('resize', handleResize)
            observer.disconnect()
        }
    }, [forceUpdate, update])
}
